import React, {useCallback, useEffect, useState} from 'react';
import MessagesTriggerButton from "./MessagesTriggerButton";
import MessagesHeader from "./MessagesList/MessagesHeader";
import SettingHeader from "./MessagesSetting/SettingHeader";
import SettingsList from "./MessagesSetting/SettingsList";
import MessagesList from "./MessagesList";
import SearchMessages from "./SearchMessages";
import Divider from "@mui/material/Divider";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Button from "@mui/material/Button";
import Div from "@jumbo/shared/Div";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import {CardActions, ThemeProvider} from "@mui/material";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import {useDispatch, useSelector} from "react-redux";
import {ListCompanyLittle, listmessage} from "../../../api/api";

const MessagesDropdown = () => {

    const {theme} = useJumboTheme();
    const {open} = useSelector(({contactsApp}) => contactsApp);
    const [showSettings, setShowSettings] = useState(open);
    const dispatch = useDispatch();
    const [Loader, setLoader] = React.useState(true);
    const [result, setResult] = React.useState([]);
    const [unread, setUnread] = React.useState(0);

    const toggleSettingWindow = useCallback(() => {
        setShowSettings(showSettings => !showSettings);
    }, [setShowSettings]);

    // useEffect(() => {
    //     // alert(open)
    //     setShowSettings(open);
    //
    //
    // }, [open]);
     useEffect(() => {
            listmessage()
                .then((response) => {
                    setResult(response.data.list)
                    setUnread(response.data.unread)
                    setLoader(false)

                })
                .catch((error) => {
                    setLoader(false)
                });

        }, []);

    return (
        <ThemeProvider theme={theme}>
            <JumboDdPopover
                triggerButton={<MessagesTriggerButton/>}
                disableInsideClick open={!showSettings}
            >
                {
                    // showSettings ?
                    //     // <Div sx={{width: 360, maxWidth: '100%'}}>
                    //     //     {/*<SettingHeader backClickCallback={toggleSettingWindow}/>*/}
                    //     //     {/*<SettingsList/>*/}
                    //     // </Div>
                    //     null
                    //     :
                    !Loader?
                     <Div sx={{width: 360, maxWidth: '100%'}}>
                            <MessagesHeader unread={unread} settingMenuCallback={toggleSettingWindow}/>
                            {/*<Div sx={{m: 2, mt: 0}}>*/}
                            {/*    <SearchMessages/>*/}
                            {/*</Div>*/}
                            <MessagesList result={result} settingMenuCallback={toggleSettingWindow} />
                            <Divider/>
                            {/*<CardActions sx={{justifyContent: 'center'}}>*/}
                            {/*    <Button*/}
                            {/*        sx={{*/}
                            {/*            textTransform: "none",*/}
                            {/*            fontWeight: 'normal',*/}
                            {/*            '&:hover': {bgcolor: 'transparent'}*/}
                            {/*        }}*/}
                            {/*        size={"small"} variant="text" startIcon={<ArrowForwardIcon/>} disableRipple>*/}
                            {/*        مشاهده همه*/}
                            {/*    </Button>*/}
                            {/*</CardActions>*/}
                        </Div>:

                        null

                }
            </JumboDdPopover>
        </ThemeProvider>
    );
};

export default MessagesDropdown;
